// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__3wy06","header_name":"header_header_name__2F2Kl","header_subtitle":"header_header_subtitle__3mR0a"};